import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agendamento-especialidade',
  templateUrl: './agendamento-especialidade.component.html',
  styleUrls: ['./agendamento-especialidade.component.css']
})
export class AgendamentoEspecialidadeComponent implements OnInit {


  ngOnInit(): void {

  }




}
